import DOMPurify from "dompurify";

/**
 * Şube sunucusundan gelen HTML parçalarını (rapor hücreleri, simgeler) süzer.
 * dangerouslySetInnerHTML'e doğrudan verilebilecek nesne döndürür.
 */
export function safeHtml(html) {
  return {
    __html: DOMPurify.sanitize(String(html ?? ""), {
      USE_PROFILES: { html: true, svg: true, svgFilters: true },
    }),
  };
}
